/*
 * General state enum can be used in any workflow.
 * Entries are not based on each other and could belong to different workflows that have nothing in common.
 * Translation-Key-Prefix: "state."
 */
export enum State {

  PENDING = 'PENDING',
  INVITED = 'INVITED',
  CONFIRMED = 'CONFIRMED',
  ACTIVATED = 'ACTIVATED',
  READED = 'READED',
  CLOSED = 'CLOSED',
  CREATED = 'CREATED',
  // Media-Upload
  UPLOADED = 'UPLOADED',
}
